
import { GooglePlacesInput } from "../../GooglePlacesInput";
import { SavedAddressSelect } from "../../saved-address/SavedAddressSelect";
import { SavedAddress } from "@/types/address";
import { GooglePlacesSelectValue } from "@/types/google-places";
import { AddressDetails } from "@/types/address";
import { useIsMobile } from "@/hooks/use-mobile";

interface AddressSelectionHeaderProps {
  apiKey: string;
  savedAddresses: SavedAddress[];
  onPlaceSelect: (place: GooglePlacesSelectValue) => void;
  onSavedAddressSelect: (addressId: string) => void;
  prefix: string;
  currentAddress: AddressDetails;
}

export const AddressSelectionHeader = ({
  apiKey,
  savedAddresses,
  onPlaceSelect,
  onSavedAddressSelect,
  prefix,
  currentAddress,
}: AddressSelectionHeaderProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex flex-col gap-3 md:flex-row md:gap-4">
      <div className="flex-1 min-w-0">
        <GooglePlacesInput
          apiKey={apiKey}
          placeholder="Start typing to Google your address..."
          onSelect={onPlaceSelect}
        />
      </div>
      <div className="w-full md:w-auto md:flex-shrink-0">
        <SavedAddressSelect
          savedAddresses={savedAddresses}
          onSelect={onSavedAddressSelect}
          prefix={prefix}
          currentAddress={currentAddress}
        />
      </div>
    </div>
  );
};
